<template>
  <div>
    <v-row>
      <v-col>
        <!-- 提示只能上傳 .xlsx 檔案 -->
        <h1 style="color: red">只能上傳.xlsx檔，xls要另存新檔成xlsx</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <!-- Excel 檔案上傳欄位 -->
        <v-file-input
          show-size
          label="拋轉銷貨單Excel"
          accept=".xlsx"
          v-model="excelFile"
          :disabled="isLoading"
        ></v-file-input>
      </v-col>
      <v-col>
        <!-- 上傳按鈕 -->
        <v-btn
          color="primary"
          class="mt-3"
          :disabled="!excelFile || isLoading"
          :loading="isLoading"
          @click="throwSunlikeSale"
        >
          拋轉
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { HttpSunlike } from '@/js/http-Manager'
export default {
  name: 'ThrowSunlikeSale',
  data: () => ({
    excelFile: null, // 上傳的 Excel 檔案
    isLoading: false // 載入狀態
  }),
  mounted () {},
  watch: {},
  computed: {},
  methods: {
    async throwSunlikeSale () {
      if (this.excelFile) {
        let formData = new FormData()
        formData.append('file', this.excelFile)
        this.isLoading = true
        let response = await HttpSunlike.ThrowSunlikeSale(formData)
        if (response && response.status === 200) {
          alert('拋轉成功')
        } else {
          alert('聯繫管理員')
        }
        this.isLoading = false
      } else {
        alert('請上傳Excel檔案')
      }
    }
  }
}
</script>
